export default __webpack_public_path__ + "static/media/arrow_w.a8bfe782.svg";